

import axios from "axios"
const evereeService={}
evereeService.searchWorker= async (term)=>{
    const config={
         url:`https://inheritguard.onrender.com/evereeapi/v1/searchworker/${term}/ign`,
        // url:`http://localhost:5000/evereeapi/v1/searchworker/${term}`,
         method:"get"
       }
      
     return axios(config)
   
      
   }

   evereeService.getWorkerById= async (id)=>{
    const config={
         url:`https://inheritguard.onrender.com/evereeapi/v1/getWorker/${id}/ign`,
        // url:`http://localhost:5000/evereeapi/v1/getWorker/${id}`,
         method:"get"
       }
      
     return axios(config)
   
   }

   evereeService.requestPayment= async (externalId,workerId)=>{
    const config={
        url:`https://inheritguard.onrender.com/evereeapi/v1/requestASAPPayment/${externalId}/${workerId}/workerId/ign`,
        // url:`http://localhost:5000/evereeapi/v1/requestASAPPayment/${externalId}/${workerId}/workerId`,
         method:"get"
       }
      
     return axios(config)
   
   }

   evereeService.createPayable= async (externalId,workerId,label,amount,type)=>{
    const config={
         url:`https://inheritguard.onrender.com/evereeapi/v1/createPayable/${externalId}/${workerId}/${label}/${amount}/${type}/workerId/ign`,
         //url:`http://localhost:5000/evereeapi/v1/createPayable/${externalId}/${workerId}/${label}/${amount}/${type}/workerId`,
         method:"get"
       }
      
     return axios(config)
   
   }
   

   evereeService.createWorker= async (firstName,lastName,phone,email)=>{
    const config={
         url:`https://inheritguard.onrender.com/evereeapi/v1/createWorker/${firstName}/${lastName}/${phone}/${email}/ign`,
        // url:`http://localhost:5000/evereeapi/v1/createWorker/${firstName}/${lastName}/${phone}/${email}`,
         method:"get"
       }
      
     return axios(config)
   
   }
   evereeService.requestPaymentExternalWorkerId= async (externalId,workerId)=>{
    const config={
         url:`https://inheritguard.onrender.com/evereeapi/v1/requestASAPPayment/${externalId}/${workerId}/externalWorkerId/ign`,
        // url:`http://localhost:5000/evereeapi/v1/requestASAPPayment/${externalId}/${workerId}/externalWorkerId`,
         method:"get"
       }
      
     return axios(config)
   
   }

   evereeService.createPayableExternalWorkerId= async (externalId,workerId,label,amount,type,)=>{
    const config={
         url:`https://inheritguard.onrender.com/evereeapi/v1/createPayable/${externalId}/${workerId}/${label}/${amount}/${type}/externalWorkerId/ign`,
        // url:`http://localhost:5000/evereeapi/v1/createPayable/${externalId}/${workerId}/${label}/${amount}/${type}/externalWorkerId`,
         method:"get"
       }
      
     return axios(config)
   
   }

  export default evereeService